import { Component, Input, OnInit, inject } from '@angular/core';
import { SettingsService, WindowService } from '@gallaghercp/core-frontend';
import { Subscription } from 'rxjs';

@Component({
    selector: 'core-dark-mode-toggle',
    templateUrl: 'dark-mode-toggle.component.html',
    standalone: false,
})
export class DarkModeToggleComponent implements OnInit {
    settings = inject(SettingsService);
    windowService = inject(WindowService);

    @Input() moonDark = false;
    darkMode!: boolean;
    darkModeEnabled?: boolean;
    subscriptions: Subscription[] = [];

    ngOnInit() {
        this.subscriptions.push(
            this.settings.isDarkModeEnabled().subscribe((state: any) => {
                this.darkModeEnabled = state;
            }),
        );

        this.subscriptions.push(
            this.settings.isDarkMode().subscribe((state: any) => {
                this.darkMode = state;
            }),
        );

        // Listen for OS Dark/Light mode changes
        if (this.windowService.matchMedia) {
            this.windowService.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
                // If OS Dark clicked
                if (event.matches) {
                    // If site currently in light mode
                    if (!this.darkMode) {
                        // change site to use dark mode
                        this.settings.toggle('isDarkMode');
                        this.darkMode = true;
                    }
                } else {
                    // If OS Light mode clicked
                    // If site currently in dark mode
                    if (this.darkMode) {
                        // change site to use light mode
                        this.settings.toggle('isDarkMode');
                        this.darkMode = false;
                    }
                }
            });
        }
    }
}
